import { Loader } from '@devd-client/devd/components';
import React, { Suspense } from 'react';

const GitLabInstallation = React.memo(
  React.lazy(() =>
    import('@devd-client/devd/ui-shared').then((module) => ({
      default: module.GitLabInstallation,
    }))
  )
);

export function AsyncGitLabInstallation() {
  return (
    <Suspense fallback={<Loader />}>
      <GitLabInstallation />
    </Suspense>
  );
}
